import Icon from '@ant-design/icons/lib/components/Icon'

const liveSvg = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="ic_fluent_live_24_filled" fill="#ffff" fill-rule="nonzero">
        <path d="M6.34277267,4.93867691 C6.73329697,5.3292012 6.73329697,5.96236618 6.34277267,6.35289047 C3.21757171,9.47809143 3.21757171,14.5450433 6.34277267,17.6702443 C6.73329697,18.0607686 6.73329697,18.6939336 6.34277267,19.0844579 C5.95224838,19.4749821 5.3190834,19.4749821 4.92855911,19.0844579 C1.02230957,15.1782083 1.02230957,8.84492646 4.92855911,4.93867691 C5.3190834,4.54815262 5.95224838,4.54815262 6.34277267,4.93867691 Z M19.0743401,4.93867691 C22.9805896,8.84492646 22.9805896,15.1782083 19.0743401,19.0844579 C18.6838158,19.4749821 18.0506508,19.4749821 17.6601265,19.0844579 C17.2696022,18.6939336 17.2696022,18.0607686 17.6601265,17.6702443 C20.7853275,14.5450433 20.7853275,9.47809143 17.6601265,6.35289047 C17.2696022,5.96236618 17.2696022,5.3292012 17.6601265,4.93867691 C18.0506508,4.54815262 18.6838158,4.54815262 19.0743401,4.93867691 Z M9.3094225,7.81205295 C9.69994679,8.20257725 9.69994679,8.83574222 9.3094225,9.22626652 C7.77845993,10.7572291 7.77845993,13.2394099 9.3094225,14.7703724 C9.69994679,15.1608967 9.69994679,15.7940617 9.3094225,16.184586 C8.91889821,16.5751103 8.28573323,16.5751103 7.89520894,16.184586 C5.58319778,13.8725748 5.58319778,10.1240641 7.89520894,7.81205295 C8.28573323,7.42152866 8.91889821,7.42152866 9.3094225,7.81205295 Z M16.267742,7.81205295 C18.5797531,10.1240641 18.5797531,13.8725748 16.267742,16.184586 C15.8772177,16.5751103 15.2440527,16.5751103 14.8535284,16.184586 C14.4630041,15.7940617 14.4630041,15.1608967 14.8535284,14.7703724 C16.384491,13.2394099 16.384491,10.7572291 14.8535284,9.22626652 C14.4630041,8.83574222 14.4630041,8.20257725 14.8535284,7.81205295 C15.2440527,7.42152866 15.8772177,7.42152866 16.267742,7.81205295 Z M12.0814755,10.5814755 C12.9099026,10.5814755 13.5814755,11.2530483 13.5814755,12.0814755 C13.5814755,12.9099026 12.9099026,13.5814755 12.0814755,13.5814755 C11.2530483,13.5814755 10.5814755,12.9099026 10.5814755,12.0814755 C10.5814755,11.2530483 11.2530483,10.5814755 12.0814755,10.5814755 Z" id="🎨-Color" />
      </g>
    </g>
  </svg>
);

const playbackSvg = () => (
  <svg width="25" height="21" viewBox="0 0 104 104" version="1.1">
    <defs />
    <g id="3.Multimedia" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g id="Multimedia-(Color)" transform="translate(-1498.000000, -98.000000)" stroke="#263238" stroke-width="3.5">
        <g id="8-multimeda-video-tape" transform="translate(1500.000000, 100.000000)">
          <path d="M50,100 C77.6142375,100 100,77.6142375 100,50 C100,22.3857625 77.6142375,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 L50,100 L50,100 Z M66,77 C72.0751322,77 77,72.0751322 77,66 C77,59.9248678 72.0751322,55 66,55 C59.9248678,55 55,59.9248678 55,66 C55,72.0751322 59.9248678,77 66,77 L66,77 L66,77 Z M66,45 C72.0751322,45 77,40.0751322 77,34 C77,27.9248678 72.0751322,23 66,23 C59.9248678,23 55,27.9248678 55,34 C55,40.0751322 59.9248678,45 66,45 L66,45 L66,45 Z M50,54 C52.209139,54 54,52.209139 54,50 C54,47.790861 52.209139,46 50,46 C47.790861,46 46,47.790861 46,50 C46,52.209139 47.790861,54 50,54 L50,54 L50,54 Z M34,77 C40.0751322,77 45,72.0751322 45,66 C45,59.9248678 40.0751322,55 34,55 C27.9248678,55 23,59.9248678 23,66 C23,72.0751322 27.9248678,77 34,77 L34,77 L34,77 Z M34,45 C40.0751322,45 45,40.0751322 45,34 C45,27.9248678 40.0751322,23 34,23 C27.9248678,23 23,27.9248678 23,34 C23,40.0751322 27.9248678,45 34,45 L34,45 L34,45 Z" id="Layer-1" fill="#FFFFFF" />
          <path d="M50,100 C50,100 75.0138441,99.5467912 88.033833,96.6530753 C101.053822,93.7593595 99.9783829,80 99.9783829,80" id="Layer-2" />
        </g>
      </g>
    </g>
  </svg>
);

const pauseSvg = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px"
    width="16.7px" height="21px" viewBox="0 0 16.7 21" enable-background="new 0 0 16.7 21">
    <g>
      <path fill="#FFFFFF" d="M6,0.3C6,0.1,5.9,0,5.7,0H0.3C0.1,0,0,0.1,0,0.3v20.5C0,20.9,0.1,21,0.3,21h5.5C5.9,21,6,20.9,6,20.7V0.3z"
      />
      <path fill="#FFFFFF" d="M16.7,0.3c0-0.1-0.1-0.3-0.3-0.3h-5.5c-0.1,0-0.3,0.1-0.3,0.3v20.5c0,0.1,0.1,0.3,0.3,0.3h5.5
		c0.1,0,0.3-0.1,0.3-0.3V0.3z"/>
    </g>
  </svg>
);

const playSvg = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    width="19.1px" height="21.3px" viewBox="0 0 19.1 21.3" enable-background="new 0 0 19.1 21.3" space="preserve">
    <g>
      <g>
        <g>
          <path fill="#FFFFFF" d="M0,0.5c0-0.4,0.3-0.6,0.7-0.4l18.1,10.2c0.4,0.2,0.4,0.6,0,0.8L0.7,21.2c-0.4,0.2-0.7,0-0.7-0.4V0.5z" />
        </g>
      </g>
    </g>
  </svg>
);

const ptzSvg = () => (
  <svg height="30" width="30" viewBox="0 0 24 24">
  <path fill="none" stroke="#FFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="m8 5 4-2.3L16 5m0 14-4 2.3L8 19m-3-4-2.3-3L5 9m14 0 2.3 3-2.3 3"/>
  <circle fill="none" stroke="#FFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="12" cy="12" r="11.5"/>
</svg>
);

const soundSvg = () => (
  <svg fill="#FFFFFF" width="25" height="25" viewBox="0 0 24 24">
    <path d="M12.43,4.1a1,1,0,0,0-1,.12L6.65,8H3A1,1,0,0,0,2,9v6a1,1,0,0,0,1,1H6.65l4.73,3.78A1,1,0,0,0,12,20a.91.91,0,0,0,.43-.1A1,1,0,0,0,13,19V5A1,1,0,0,0,12.43,4.1ZM11,16.92l-3.38-2.7A1,1,0,0,0,7,14H4V10H7a1,1,0,0,0,.62-.22L11,7.08ZM15.14,4.09a1,1,0,1,0-.28,2,6,6,0,0,1,0,11.86,1,1,0,0,0,.14,2h.14a8,8,0,0,0,0-15.82Zm-.46,9.78a1,1,0,0,0,.32,2,1.13,1.13,0,0,0,.32-.05,4,4,0,0,0,0-7.54,1,1,0,0,0-.64,1.9,2,2,0,0,1,0,3.74Z" />
  </svg>
);

const soundMuteSvg = () => (
  <svg fill="#FFFFFF" width="25" height="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.43,4.1a1,1,0,0,0-1,.12L6.65,8H3A1,1,0,0,0,2,9v6a1,1,0,0,0,1,1H6.65l4.73,3.78A1,1,0,0,0,12,20a.91.91,0,0,0,.43-.1A1,1,0,0,0,13,19V5A1,1,0,0,0,12.43,4.1ZM11,16.92l-3.38-2.7A1,1,0,0,0,7,14H4V10H7a1,1,0,0,0,.62-.22L11,7.08ZM19.91,12l1.8-1.79a1,1,0,0,0-1.42-1.42l-1.79,1.8-1.79-1.8a1,1,0,0,0-1.42,1.42L17.09,12l-1.8,1.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l1.79-1.8,1.79,1.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
  </svg>
);

const microMuteSvg = () => (
  <svg fill="#FFFF" width="25px" height="25px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5,3.73a2,2,0,0,1,2.95-.14A2,2,0,0,1,14,5V8.41a1,1,0,0,0,2,0V5A4,4,0,0,0,9,2.47,1,1,0,1,0,10.5,3.73Zm8.22,9.54.2,0a1,1,0,0,0,1-.81A7.91,7.91,0,0,0,20,11a1,1,0,0,0-2,0,5.54,5.54,0,0,1-.11,1.1A1,1,0,0,0,18.72,13.27Zm3,6.06-18-18a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41L8,8.48V11a4,4,0,0,0,6,3.46l1.46,1.46A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93a7.87,7.87,0,0,0,3.85-1.59l3.4,3.4a1,1,0,0,0,1.42-1.41ZM12,13a2,2,0,0,1-2-2v-.52l2.45,2.46A1.74,1.74,0,0,1,12,13Z" />
  </svg>
);

const microActiveSvg = () => (
  <svg fill="#FF0505" width="25px" height="25px" viewBox="0 0 24 24">
    <path d="M12,15a4,4,0,0,0,4-4V5A4,4,0,0,0,8,5v6A4,4,0,0,0,12,15ZM10,5a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0Zm10,6a1,1,0,0,0-2,0A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93A8,8,0,0,0,20,11Z" />
  </svg>
);

const playBackwardsSvg = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px"
    width="19.1px" height="21.3px" viewBox="0 0 19.1 21.3" enable-background="new 0 0 19.1 21.3">
    <g>
      <g>
        <g>
          <path fill="#FFFFFF" d="M19.1,20.8c0,0.4-0.3,0.6-0.7,0.4L0.3,11c-0.4-0.2-0.4-0.6,0-0.8L18.4,0.1c0.4-0.2,0.7,0,0.7,0.4V20.8z"
          />
        </g>
      </g>
    </g>
  </svg>
);

const playForwardsSvg = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px"
    width="19.1px" height="21.3px" viewBox="0 0 19.1 21.3" enable-background="new 0 0 19.1 21.3">
    <g>
      <g>
        <g>
          <path fill="#FFFFFF" d="M0,0.5c0-0.4,0.3-0.6,0.7-0.4l18.1,10.2c0.4,0.2,0.4,0.6,0,0.8L0.7,21.2c-0.4,0.2-0.7,0-0.7-0.4V0.5z" />
        </g>
      </g>
    </g>
  </svg>
);

const ptzControlSvg = () => (
  <svg height="24" width="24" version="1.1" id="Layer_1"
    viewBox="0 0 50 50" enable-background="new 0 0 50 50">
    <path fill="#FFFF" d="M15.563,40.836c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l15-15
    c0.391-0.391,0.391-1.023,0-1.414l-15-15c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l14.293,14.293L15.563,39.422
    C15.172,39.813,15.172,40.446,15.563,40.836z"/>
  </svg>
)

const ptzHomeSvg = () => (
  <svg width="25" height="25" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">

    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <circle id="Circle" stroke="#FFFF" stroke-width="2" cx="32" cy="32" r="31">

      </circle>
    </g>
  </svg>
)

const zoomInSvg = () => (
  <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 14.5L10.5 10.5M6.5 4V9M4 6.5H9M6.5 12.5C3.18629 12.5 0.5 9.81371 0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5C12.5 9.81371 9.81371 12.5 6.5 12.5Z" stroke="#FFFF" />
  </svg>
)

const zoomOutSvg = () => (
  <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 14.5L10.5 10.5M4 6.5H9M6.5 12.5C3.18629 12.5 0.5 9.81371 0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5C12.5 9.81371 9.81371 12.5 6.5 12.5Z" stroke="#FFFF" />
  </svg>
)

const LiveIcon = (props) => <Icon component={liveSvg} {...props} />;
const PlaybackIcon = (props) => <Icon component={playbackSvg} {...props} />;
const PlayIcon = (props) => <Icon component={playSvg} {...props} />;
const PauseIcon = (props) => <Icon component={pauseSvg} {...props} />;
const PtzIcon = (props) => <Icon component={ptzSvg} {...props} />;
const SoundIcon = (props) => <Icon component={soundSvg} {...props} />;
const SoundMute = (props) => <Icon component={soundMuteSvg} {...props} />;
const MicroMuteIcon = (props) => <Icon component={microMuteSvg} {...props} />;
const MicroActiveIcon = (props) => <Icon component={microActiveSvg} {...props} />;
const PlayBackwardsIcon = (props) => <Icon component={playBackwardsSvg} {...props} />;
const PlayForwardsIcon = (props) => <Icon component={playForwardsSvg} {...props} />;
const PtzControlIcon = (props) => <Icon component={ptzControlSvg} {...props} />
const PtzHomeIcon = (props) => <Icon component={ptzHomeSvg} {...props} />
const ZoomInIcon = (props) => <Icon component={zoomInSvg} {...props} />
const ZoomOutIcon = (props) => <Icon component={zoomOutSvg} {...props} />

export {
  PlaybackIcon,
  LiveIcon,
  PauseIcon,
  PlayIcon,
  PtzIcon,
  SoundIcon,
  SoundMute,
  MicroMuteIcon,
  MicroActiveIcon,
  PlayBackwardsIcon,
  PlayForwardsIcon,
  PtzControlIcon,
  PtzHomeIcon,
  ZoomInIcon,
  ZoomOutIcon
}